import { ImmersHUD } from './source/ImmersHUD/ImmersHUD.js'
ImmersHUD.Register()
